import React from 'react'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'
import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';
import { Tooltip } from '../../../../components/Tooltip/Tooltip';

const DatosProductoSuma = (props: any) => {
  return (
    <table className='w-100'>
      <tbody>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-gray' style={{marginRight: '3%'}}>
              Subtotal
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-gray'>
              ${props?.subtotal ? convertirNumeroConComas(props?.subtotal) : '0.00'}
            </div>
          </td>
        </tr>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-gray' style={{marginRight: '3%'}}>
              Descuento
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-red'>
              ${props?.descuento ? convertirNumeroConComas(props?.descuento) : '0.00'}
            </div>
          </td>
        </tr>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-gray opacity-full-gray' style={{marginRight: '3%'}}>
              <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                <button className='table-action no-background'>
                  <img src={HelpIcon} className='help-icon-button' />
                </button>
              </Tooltip>
              Otros impuestos
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-gray'>
              ${props?.otrosImpuestos ? convertirNumeroConComas(props?.otrosImpuestos) : '0.00'}
            </div>
          </td>
        </tr>
        <tr>
          <td className='label-column-fact align-end'>
            <div className='div-calculo-p-black' style={{marginRight: '3%'}}>
              Total
            </div>
          </td>
          <td className='total-column-fact align-end'>
            <div className='div-calculo-p-secondary'>
              ${props.total ? convertirNumeroConComas(props?.total) : '0.00'}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default DatosProductoSuma
